import { useNavigate } from 'react-router-dom';

const ReferNotFoundState = ({ agentParam }) => {
  const navigate = useNavigate();

  return (
    <div className="py-6 w-full">
      <div className="w-20 h-20 bg-slate-100 rounded-2xl mx-auto flex items-center justify-center text-4xl mb-6 shadow-sm border border-slate-200">
        🧭
      </div>
      <h1 className="text-2xl font-bold text-slate-800 mb-3 tracking-tight">
        Agent Profile Not Found
      </h1>
      <p className="text-slate-600 text-[15px] leading-relaxed mb-8 font-medium">
        We couldn't find a registration record for "{agentParam || 'this agent'}". Let's get you back to the main portal.
      </p>
      <button
        onClick={() => navigate('/login')}
        className="bg-[#067978] hover:bg-[#045d5c] text-white font-bold py-3 px-8 rounded-full transition-all shadow-[0_8px_20px_rgba(6,121,120,0.3)] hover:-translate-y-0.5 border border-[#067978]/50 text-sm cursor-pointer"
      >
        Go to Login Page
      </button>
    </div>
  );
};

export default ReferNotFoundState;
